// extracted by mini-css-extract-plugin
export default {"fullWidth":"Yo-z","image":"Zo-z","lazyLoadPicture":"_o-z","lazyLoadSpinner":"ap-z","lazyLoadSpin":"bp-z","lazyLoadImage":"cp-z","hasStyledAspectRatio":"dp-z"};